import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight16, Plus } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { useOpenCreateGoalDialog } from 'shared/contexts/goal-form';
import { Goal } from 'shared/types/goal';

export type MoveGoalListProps = {
  goal: Goal;
  onClose: () => void;
  openGoalSelect: () => void;
};

export const MoveGoalList: React.FC<MoveGoalListProps> = ({
  goal,
  onClose,
  openGoalSelect,
}) => {
  const { t } = useTranslation();
  const openCreateGoalDialog = useOpenCreateGoalDialog();

  const onCreateSubGoal = (e: React.MouseEvent) => {
    e.preventDefault();
    openCreateGoalDialog({ parentIds: [goal.id] });

    onClose();
  };

  const onGoalSelect = (e: React.MouseEvent) => {
    e.preventDefault();
    openGoalSelect();
  };

  return (
    <PopupMenuList hasBottomBorder>
      <PopupMenuListItem>
        <PopupMenuButton
          onClick={onGoalSelect}
          start={<Icon icon={ArrowRight16} />}
        >
          {t('context-menus.goal.labels.move-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
      <PopupMenuListItem>
        <PopupMenuButton onClick={onCreateSubGoal} start={<Icon icon={Plus} />}>
          {t('context-menus.goal.labels.add-sub-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
